export default {
  namespaced: true,
  state: {
    isStartDrawing: false,
    toolType: 0,
    annotationType: 0,
    showPhoto: false,
    photoObject: {
      photoIds: []
    },
    showFile: false,
    fileObject: {
      fileId: null,
      fileName: null,
      position: {
        x: 0,
        y: 0
      }
    },
    commentObjId: null,
    showComments: false,
    isStartTakeOffMeasure: false,
    overlayLayers: [],
    showColorBox: false,
    showEditTakeOff: false,
    selectedTakeOff: {},
    selectedObjectColor: null,
    selectObjectName: null,
    calibrationList: [],
    activeCalibration: {
      uuid: 1,
      name: '1',
      type: 'standard',
      value: 1,
    },
    activeTakeOff: {
      uuid: null,
      name: null,
      label: null,
      location: null,
      path_style: {
        strokeColor: 'red',
      },
      assembly: null,
      materials: [],
    },
    deletedObjects:[],
    drawingBgColor: '#FF0000',
    drawingTextColor: '#000000',
    showFontSize: false,
    setFontSize: 14,
    copyObject: {
      layerName: 'toolLayer',
      object: null,
    },
    showReport: false,
    visualGroupId: null,
    drawerWidth: 1400,
    isCopy: false,
  },
  getters: {
    getIsStartDrawing: state => state.isStartDrawing,
    getToolType: state => state.toolType,
    getAnnotationType: state => state.annotationType,
    getCommentObjId: state => state.commentObjId,
    getActiveTakeOff: state => state.activeTakeOff,
    getIsTakeOffMeasureStarted: state => state.isStartTakeOffMeasure,
    getOverlayLayers: state => state.overlayLayers,
    getActiveCalibrationName: state => state.activeCalibration.name,
    getActiveCalibration: state => state.activeCalibration,
    getCalibrationList: state => state.calibrationList,
    showComments: state => state.showComments,
    getShowColorBox: state => state.showColorBox,
    getSelectedObjectName: state => state.selectObjectName,
    getShowEditTakeOff: state => state.showEditTakeOff,
    getSelectedTakeOff: state => state.selectedTakeOff,
    getDeletedObjects: state => state.deletedObjects,
    getPhotoObject: state => state.photoObject,
    showPhotoModal: state => state.showPhoto,
    showFileModal: state => state.showFile,
    getDrawingBgColor: state => state.drawingBgColor,
    getDrawingTextColor: state => state.drawingTextColor,
    getDrawingFillColor: state => state.drawingFillColor,
    getFilePosition: state => state.fileObject.position,
    getFileObject: state => state.fileObject,
    getFileName: state => state.fileObject.fileName,
    getShowFontSize: state => state.showFontSize,
    getFontSize: state => state.setFontSize,
    getCopyObject: state => state.copyObject,
    showReport: state => state.showReport,
    getVisualGroupId: state => state.visualGroupId,
    getDrawerWidth: state => state.drawerWidth,
    getIsCopy: state => state.isCopy,
  },
  mutations: {
    SET_COPY_OBJECT(state, payload){
      state.copyObject = payload
    },
    SET_OPEN_PHOTO(state, payload){
      state.showPhoto = true
      state.photoObject = payload
    },
    SET_OPEN_FILE(state, payload){
      state.showFile = true
      state.fileObject = payload
    },
    SET_SHOW_PHOTO(state, payload) {
      state.showPhoto = payload
    },
    SET_SHOW_FILE(state, payload) {
      state.showFile = payload
    },
    SET_CLOSE_PHOTO(){
      state.showPhoto = false
      state.photoObject = {}
    },
    SET_TOOL_TYPE(state, payload) {
      state.toolType = payload
    },
    SET_ANNOTATION_TYPE(state, payload) {
      state.annotationType = payload
    },
    SET_IS_START_DRAWING(state, payload) {
      state.isStartDrawing = payload
    },
    SET_ANNOTATION_SELECT(state, payload) {
      state.isToolSelect = payload
    },
    SET_COMMENT_OBJ_ID(state, payload) {
      state.commentObjId = payload
    },
    SET_START_TAKE_OFF_MEASURE(state, payload) {
      state.isStartTakeOffMeasure = true
      state.activeTakeOff = payload
    },
    SET_STOP_TAKE_OFF_MEASURE(state) {
      state.isStartTakeOffMeasure = false
      state.activeTakeOff = {
        uuid: null,
        name: null,
        label: null,
        location: null,
        path_style: {
          strokeColor: 'red',
        },
        assembly: null,
        materials: [],
      }
    },
    SET_OVERLAY_LAYER(state, payload) {
      state.overlayLayers.push({ ...payload.page, ...{ overlay: true, visible: true } })
    },
    SET_ACTIVE_CALIBRATION(state, payload) {
      state.activeCalibration = payload
    },
    UPDATE_CALIBRATION_LIST(state, payload){
      if(!state.calibrationList.find(i => i.uuid === payload.uuid)){
        state.calibrationList.push(payload)
      }
    },
    SET_CALIBRATION_LIST(state, payload){
      state.calibrationList = []
      payload.forEach(c => {
        if(!state.calibrationList.find(i => i.uuid === c.uuid)){
          state.calibrationList.push(c)
        }
      })
    },
    RESET_STATE(state) {
      state.overlayLayers = []
      state.calibrationList = []
      state.toolType = 0
      state.isStartDrawing = false
      state.activeCalibration = {
        uuid: 1,
        name: '1',
        type: 'standard',
        value: 1,
      }
    },
    SET_SHOW_COMMENT(state, payload) {
      state.showComments = payload
    },
    SHOW_EDIT_TAKE_OFF(state, payload) {
      state.showEditTakeOff = payload
    },
    UPDATE_MATERIALS_ON_TAKE_OFF(state, payload) {
      if (payload.uuid === state.activeTakeOff.uuid) {
        state.activeTakeOff.materials = payload.materials
      }
    },
    SHOW_COLOR_BOX(state, payload) {
      state.showColorBox = payload
    },
    SET_OBJECT_NAME(state, payload) {
      state.selectObjectName = payload
    },
    SET_SELECTED_TAKE_OFF(state, payload) {
      state.selectedTakeOff = payload
    },
    SET_DELETED_OBJECTS(state, payload) {
      state.deletedObjects = payload
    },
    SET_DRAWING_BG_COLOR(state, payload){
      state.drawingBgColor = payload
    },
    SET_DRAWING_TEXT_COLOR(state, payload){
      state.drawingTextColor = payload
    },
    SET_DRAWING_FILL_COLOR(state, payload){
      state.drawingFillColor = payload
    },
    SHOW_FONT_SIZE(state, payload) {
      state.showFontSize = payload
    },
    SET_FONT_SIZE(state, payload) {
      state.setFontSize = payload
    },
    SET_SHOW_REPORT(state, payload) {
      state.showReport = payload
    },
    SET_VISUAL_GROUP_ID(state, payload) {
      state.visualGroupId = payload
    },
    SET_DRAWER_WIDTH(state, payload){
      state.drawerWidth = payload
    },
    SET_IS_COPY(state, payload){
      state.isCopy=payload
    },
  },
}
